import React from 'react';
import { Modal, Box, Grid, Typography, Button } from '@mui/material';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/utils/info.svg';

import useStyles from '../../../assets/styles/pages/ShopRequest';

import { FormatPrice } from '../../../helpers/utils/Formating';

interface Props {
  open: boolean;
  onClose: () => void;
  vlFaltaFreteGratis: number;
  idRestaurante: string;
  handleToPage: (path: string) => void;
}

const styleModalBottom = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

export const AddItemCartModal = ({
  open,
  onClose,
  vlFaltaFreteGratis,
  idRestaurante,
  handleToPage,
}: Props): JSX.Element => {
  const classeStyle = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModalBottom}>
        <Grid container item xs={12} justifyContent="center">
          <IconInfo className={classeStyle.iconModal} />
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Typography
            variant="h6"
            component="h2"
            className={classeStyle.titleModal}
            style={{
              fontWeight: '550',
              width: '100%',
              textAlign: 'center',
            }}
          >
            Atenção
          </Typography>

          <Typography sx={{ mt: 2 }} className={classeStyle.textModal}>
            {`Falta apenas ${FormatPrice(
              vlFaltaFreteGratis,
            )} para ganhar frete grátis`}
          </Typography>
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Button
            className={classeStyle.btnSubmit}
            style={{ width: '80%' }}
            onClick={() =>
              handleToPage(
                `/shop/detail/list/product/subcategorie/${idRestaurante}`,
              )
            }
            variant="contained"
          >
            ADICIONAR ITENS
          </Button>

          <Button
            className={classeStyle.textBtnKeepShopping}
            style={{ width: '80%' }}
            onClick={onClose}
          >
            Voltar
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};
